import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Link } from '@mui/material';

// `white`: el logo original tiene el contorno, la mira y la silueta en NEGRO
// sobre fondo transparente, así que sobre un fondo oscuro desaparece. Este
// filtro lo pasa a blanco sólido para que siempre se lea (pedido del cliente
// 2026-09-10). Sobre fondos claros se usa el logo a color, como siempre.
const Logo = forwardRef(({ disabledLink = false, white = false, sx, ...other }, ref) => {
  const logo = (
    <Box
      ref={ref}
      component="div"
      sx={{
        width: 40,
        height: 40,
        display: 'inline-flex',
        flexShrink: 0,
        ...sx,
      }}
      {...other}
    >
      <img
        src="https://bbtargetcenter.com/wp-content/uploads/2020/03/53201072_2501641786530857_5217031044271702016_o-1-1.png"
        alt="BBTC Logo"
        style={{
          objectFit: 'contain',
          width: '100%',
          height: '100%',
          borderRadius: 8,
          ...(white ? { filter: 'brightness(0) invert(1)' } : {}),
        }}
      />
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return (
    <Link to="/" component={RouterLink} sx={{ display: 'contents' }}>
      {logo}
    </Link>
  );
});

Logo.propTypes = {
  sx: PropTypes.object,
  disabledLink: PropTypes.bool,
  white: PropTypes.bool,
};

export default Logo;
